import type { ReactNode } from 'react'

import { cn } from '@/lib/cn'

import { Container } from './Container'

export function Section({
  children,
  className,
  containerClassName,
  size = 'default',
  id,
}: {
  children: ReactNode
  className?: string
  containerClassName?: string
  size?: 'default' | 'narrow' | 'wide'
  id?: string
}) {
  return (
    <section id={id} className={cn('py-14 sm:py-20 lg:py-28', className)}>
      <Container size={size} className={containerClassName}>
        {children}
      </Container>
    </section>
  )
}

export function SectionHeading({
  eyebrow,
  title,
  lead,
  align = 'left',
}: {
  eyebrow?: string
  title: string
  lead?: string
  align?: 'left' | 'center'
}) {
  return (
    <header className={cn('max-w-2xl', align === 'center' && 'mx-auto text-center')}>
      {eyebrow ? <p className="eyebrow mb-3">{eyebrow}</p> : null}
      <h2 className="text-3xl sm:text-4xl lg:text-5xl">{title}</h2>
      {lead ? <p className="mt-4 text-base text-muted sm:text-lg">{lead}</p> : null}
    </header>
  )
}
